<form
  [formGroup]="loanForm"
  autocomplete="off"
  (ngSubmit)="onSubmit(loanForm.value)"
  class="loan-form"
>
  <div class="row">
    <div
      class="col-sm-6 form-group"
      [ngClass]="{
        'has-error':
          !loanForm.get('metadata.typeProject').valid &&
          loanForm.get('metadata.typeProject').touched,
      }"
    >
      <label class="text-gray" for="loanTypeProjectLabel">{{
        'pages.loan.name' | translate
      }}</label>
      <select
        name="typeProject"
        [formControl]="loanForm.get('metadata.typeProject')"
        class="form-control"
      >
        @for (item of typeProjetList; track item) {
          <option value="{{ item.id }}">
            {{ item.value | translate }}
          </option>
        }
      </select>
    </div>

    <div
      class="col-sm-6 form-group"
      [ngClass]="{
        'has-error':
          !loanForm.get('metadata.label').valid &&
          loanForm.get('metadata.label').touched,
      }"
    >
      <label class="text-gray" for="loanTypeProjectLabel">{{
        'pages.loan.label' | translate
      }}</label>
      <input
        id="loanAmountLabel"
        type="text"
        name="label"
        [formControl]="loanForm.get('metadata.label')"
        class="form-control"
      />
    </div>
  </div>

  <div class="row">
    <div
      class="col-sm-6 form-group"
      [ngClass]="{
        'has-error':
          !loanForm.get('data.amount').valid &&
          loanForm.get('data.amount').touched,
      }"
    >
      <label class="text-gray" for="loanAmountLabel">
        {{ 'pages.loan.totalAmount' | translate }}
        <span class="star">*</span>
      </label>
      <div class="input-group">
        <input
          id="loanAmountLabel"
          type="number"
          min="0"
          name="amount"
          [formControl]="loanForm.get('data.amount')"
          class="form-control"
        />
        <div class="input-group-addon">
          <i class="fa fa-eur text-primary"></i>
        </div>
      </div>
    </div>

    <div class="col-sm-6 form-group">
      <label class="text-gray" for="loanAmountLabel">{{
        'pages.loan.monthlyFee' | translate
      }}</label>
      <div class="input-group">
        <input
          readonly
          id="loanAmountLabel"
          type="text"
          name="monthAmount"
          [formControl]="loanForm.get('data.monthAmount')"
          class="form-control"
        />
        <div class="input-group-addon">
          <i class="fa fa-eur text-primary"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div
      class="col-sm-6 form-group"
      [ngClass]="{
        'has-error':
          !loanForm.get('data.rate').valid && loanForm.get('data.rate').touched,
      }"
    >
      <label class="text-gray" for="loanRateLabel">{{
        'pages.loan.head.title7' | translate
      }}</label>
      <div class="input-group">
        <input
          id="loanRateLabel"
          type="number"
          min="0"
          step="0.01"
          name="rate"
          [formControl]="loanForm.get('data.rate')"
          class="form-control"
        />
        <div class="input-group-addon">
          <i class="fa fa-percent text-primary"></i>
        </div>
      </div>
    </div>
    <div
      class="col-sm-6 form-group"
      [ngClass]="{
        'has-error':
          !loanForm.get('data.insuranceRate').valid &&
          loanForm.get('data.insuranceRate').touched,
      }"
    >
      <label class="text-gray" for="loanInsuranceRateLabel">{{
        'pages.loan.head.title8' | translate
      }}</label>
      <div class="input-group">
        <input
          id="loanInsuranceRateLabel"
          type="number"
          step="0.01"
          min="0"
          name="insuranceRate"
          [formControl]="loanForm.get('data.insuranceRate')"
          class="form-control"
        />
        <div class="input-group-addon">
          <i class="fa fa-percent text-primary"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div
      class="col-sm-12 form-group"
      [ngClass]="{
        'has-error':
          !loanForm.get('data.duration').valid &&
          loanForm.get('data.duration').touched,
      }"
    >
      <label class="text-gray" for="loanDurati@onLabel">{{
        'pages.loan.duration' | translate
      }}</label>
      <div class="input-group">
        <input
          id="loanDurationLabel"
          type="number"
          min="1"
          name="duration"
          [formControl]="loanForm.get('data.duration')"
          class="form-control"
        />
        <div class="input-group-addon text-primary text-month">
          {{ 'pages.common.month' | translate }}
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 form-group">
      <label class="text-gray" for="loanDateTimeLabel">{{
        'pages.common.signatureDate' | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          placeholder="{{ signatureDate | date: 'shortDate' }}"
          class="form-control"
          #dpLoanStart="bsDatepicker"
          bsDatepicker
          [(bsValue)]="signatureDate"
          [bsConfig]="bsConfig"
        />
        <div class="input-group-addon" (click)="dpLoanStart.toggle()">
          <i class="fa fa-calendar text-primary"></i>
        </div>
      </div>
    </div>
    <div class="col-sm-6 form-group">
      <label class="text-gray" for="loanDateTimeLabel">{{
        'pages.common.startDate' | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          placeholder="{{ startDate | date: 'shortDate' }}"
          class="form-control"
          #dpLoanStart="bsDatepicker"
          bsDatepicker
          [(bsValue)]="startDate"
          [bsConfig]="bsConfig"
        />
        <div class="input-group-addon" (click)="dpLoanStart.toggle()">
          <i class="fa fa-calendar text-primary"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="pvm text-center">
    <ea-popover-confirm (confirm)="onDeleteConfirm($event)">
      <button
        type="button"
        class="btn btn-outline btn-danger semi-bold mhm"
        [disabled]="loading"
      >
        <i
          class="fa fa-remove text-danger"
          [ngClass]="{ 'fa-remove': !loading, 'fa-spinner fa-spin': loading }"
        ></i>
        {{ 'pages.action.delete' | translate }}
      </button>
    </ea-popover-confirm>
    @if (isEstate) {
      <button
        type="button"
        class="btn btn-outline semi-bold mhm"
        (click)="onDissociate()"
        [disabled]="loading"
      >
        <i class="fa fa-remove text-danger"></i>
        {{ 'pages.action.dissociate' | translate }}
      </button>
    }
    <button
      type="submit"
      class="btn btn-outline btn-success-flat semi-bold mhm"
      [disabled]="!loanForm.valid || loading"
    >
      <i class="fa fa-save"></i> {{ 'pages.action.save' | translate }}
    </button>
  </div>
</form>
